import { useMemo, useState } from 'react';
import { popularManga } from '@/mocks/manga';
import MangaCard from './MangaCard';
import SectionHeader from './SectionHeader';

const tabs = ['全部', '热血', '恋爱', '玄幻', '悬疑', '科幻', '校园', '都市', '奇幻', '搞笑'];

export default function PopularSection() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? popularManga : popularManga.filter((m) => m.category === active)),
    [active],
  );

  return (
    <section id="popular" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeader
            eyebrow="本周热榜"
            title="热门漫画推荐"
            desc="飞飞漫画网人气作品抢先看，翻页流畅、更新及时，热门佳作一键开读。"
          />
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setActive(t)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors cursor-pointer ${
                  active === t
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:bg-background-50 hover:text-foreground-900'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 md:gap-5">
          {list.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>
      </div>
    </section>
  );
}